import React, { useState, useEffect } from "react";
import packageJson from "../../package.json";
import moment from "moment";

const buildDateGreaterThan = (latestDate: any, currentDate: any) => {
	const momLatestDateTime = moment(latestDate);
	const momCurrentDateTime = moment(currentDate);

	if (momLatestDateTime.isAfter(momCurrentDateTime)) {
		return true;
	} else {
		return false;
	}
};

function withClearCache(Component: any) {
	function ClearCacheComponent(props: any) {
		const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

		useEffect(() => {
			fetch("/meta.json")
				.then((response) => {
					return response.json();
				})
				.then((meta) => {
					const latestVersionDate = meta.buildDate;
					const currentVersionDate = packageJson.buildDate;
					const shouldForceRefresh = buildDateGreaterThan(
						latestVersionDate,
						currentVersionDate
					);
					console.log({
						shouldForceRefresh,
					});
					if (shouldForceRefresh) {
						setIsLatestBuildDate(false);
						refreshCacheAndReload();
					} else {
						setIsLatestBuildDate(true);
					}
				});
		}, []);

		const refreshCacheAndReload = () => {
			if (caches) {
				// Service worker cache should be cleared with caches.delete()
				caches.keys().then((names) => {
					for (const name of names) {
						caches.delete(name);
					}
				});
			}
			// delete browser cache and hard reload
			window.location.reload();
			// alert("Reloaded");
		};

		return (
			<React.Fragment>
				{isLatestBuildDate ? <Component {...props} /> : null}
			</React.Fragment>
		);
	}

	return ClearCacheComponent;
}

export default withClearCache;
